import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-4/5">
    <vx-card>
      <div class="inline-flex w-4/5 pb-2 mt-3">
        <div class="columns">
          <div
            class="column is-narrow mt-3"
            style="width: 250px; text-align: right"
          >
            <span>Request Number</span>
          </div>
          <div class="column is-narrow -mt-3">
            <div style="width: 200px">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-code"
                icon-no-border
                label-placeholder="Request Number"
                v-model="chRequestsNumber"
                :readonly="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 mt-3">
        <div class="column is-narrow" style="width: 250px; text-align: right">
          <span>Inbound Number</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="inbordersNumber"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                    disabled="disabled"
                  @click="searchInb"
                  >ดึงข้อมูล Inbound</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="columns mt-1">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>MAWB</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 1"
              v-model="mawb"
              :readonly="true"
            />
          </div>
        </div>

        <div
          class="column is-narrow mt-4"
          style="width: 100px; text-align: right"
        >
          <span>HAWB</span>
        </div>
        <div class="column is-narrow -mt-2">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 2"
              v-model="hawb"
              :readonly="true"
            />
          </div>
        </div>

        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>Invoice No.</span>
        </div>
        <div class="column is-narrow -mt-3">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="Invoice"
              v-model="invnum"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-2/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="SKUS_Code"
            v-model="skus_code"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2" v-if="0 == 1">
        <div class="vx-col w-1/5 pr-6">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ItemNumber"
            v-model="inbitemnum"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 -mt-2">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span></span>
        </div>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Package"
            @blur="$v.itempck.$touch()"
            v-model="itempck"
          />
        </div>
        <p v-if="$v.itempck.$error & $v.itempck.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="packagesCode"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span></span>
        </div>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="G/W"
            @blur="$v.itemgw.$touch()"
            v-model="itemgw"
          />
        </div>
        <p v-if="$v.itemgw.$error & $v.itemgw.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-1/5 pr-6">
          <vs-input
            :readonly="true"
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Unit"
            v-model="gwunit"
          />
        </div>
      </div>

      <div class="columns mt-2 -mb-4">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>จาก ประเภท</span>
        </div>
        <div class="column is-narrow mt-2">
          <div style="width: 200px">
            <vs-select
              autocomplete
              v-model="tmotypes_code"
              disabled="disabled"
              class="w-full"
            >
              <vs-select-item
                v-for="tmotype in tmotypes"
                :key="tmotype.code"
                :value="tmotype.code"
                :text="tmotype.name"
              />
            </vs-select>
            <p v-if="$v.tmotypes_code.$error & $v.tmotypes_code.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-2 -mb-4">
        <div
          class="column is-narrow mt-4"
          style="width: 250px; text-align: right"
        >
          <span>ไปเป็น ประเภท</span>
        </div>
        <div class="column is-narrow mt-2">
          <div style="width: 200px">
            <vs-select autocomplete 
            v-model="ntmotypesCode" 
              disabled="disabled"
            class="w-full">
              <vs-select-item
                v-for="tmotype in tmotypes_new"
                :key="tmotype.code"
                :value="tmotype.code"
                :text="tmotype.name"
              />
            </vs-select>
            <p v-if="$v.ntmotypesCode.$error & $v.ntmotypesCode.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns -mt-6">
        <div
          class="column is-narrow mt-6"
          style="width: 250px; text-align: right"
        >
          <span>เหตุผลการดำเนินการ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Reason"
              v-model="chreason"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <!-- <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          > -->
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vs-popup fullscreen title="Inbound Number" :active.sync="popupActive6">
      <inborders
        v-if="popupActive6"
        :companyGroupsCode="companyGroupsCode"
        :masrec="0"
        @recsel="recsel"
      ></inborders>
    </vs-popup>
  </div>
</template>

<script>
import { required, decimal } from "vuelidate/lib/validators";
import moment from "moment";
import inborders from "./inbdetailsgridchange.vue";
import customsports from "../customsports/grid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      chreason: "",
      chRequestsNumber: "",
      connumber: "",
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      indclnumber: "",
      dcldate: "",
      shname: "",
      cnname: "",
      description: "",
      dest: "",
      destname: "",
      pol: "",
      polname: "",
      pols: [],
      pod: "",
      podname: "",
      tmotypes_code: "",
      tmotypes: [],
      ntmotypesCode: "",
      tmotypes_new: [],
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      repdate: "",
      skus_code: "",
      qtyunit: "",
      itemgw: "",
      gwunit: "",
      itemnw: "",
      nwunit: "",
      itempck: "",
      packagesCode: "",
      dclnumber: "",
      mawb: "",
      hawb: "",
      exbdetails: "",
      exbordersNumber: "",
      invnum: "",
      itemnum: "",
      inbordersNumber: "",
      inbitemnum: "",
      itemqty: "",
      remark: "",
      status: "",
      readonly: false,
      popupActive6: false,
      popupActive2: false,
      popupActive7: false,
    };
  },
  validations: {
    itempck: {
      required,
      decimal,
    },

    itemgw: {
      required,
      decimal,
    },
    tmotypes_code: {
      required,
    },
    ntmotypesCode: {
      required,
    },
    // pod: {
    //   required,
    // },
    // dest: {
    //   required,
    // },
  },
  components: {
    inborders,
    customsports,
  },
  props: ["acstate", "recid", "masrec"],
  methods: {
    async recsel(val) {
      this.inbordersNumber = val;
      // console.log(this.inbordersNumber);
      this.popupActive6 = false;

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        skus_code: val,
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/chrequests/getInbDetail`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.inbordersNumber = response.data.inbordersNumber;
            this.inbitemnum = response.data.itemnum;
            this.description = response.data.edescription;
            this.itempck = response.data.itempck;
            this.packagesCode = response.data.packagesCode;
            this.itemnw = response.data.itemnw;
            this.nwunit = response.data.nwunit;
            this.itemgw = response.data.itemgw;
            this.gwunit = response.data.gwunit;
            this.itemqty = response.data.itemqty;
            this.qtyunit = response.data.qtyunit;
            this.mawb = response.data.mawb;
            this.hawb = response.data.hawb;
            this.skus_code = response.data.skus_code;
            this.tmotypes_code = response.data.tmotypes_code;
            this.dest = response.data.dest;
            this.pod = response.data.pod;
            this.shname = response.data.shname;
            this.cnname = response.data.cnname;
            this.indclnumber = response.data.dclnumber;
            this.invnum = response.data.invnum;
            this.dcldate = response.data.dcldate;

            // setTimeout(() => {
            //   this.onModes2();
            //   this.onModes7();
            // }, 500);
            this.tmotypes_new = [];
            this.ntmotypesCode = "";

            setTimeout(() => {
              this.checkForType(response.data.inbordersNumber);
            }, 300);
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    checkForType(number) {
      let inb = number;
      let dgc = inb.substring(0, 2);
      let inbfrom = "";
      // alert(dgc);
      if (dgc == "BM") {
        inbfrom = "CMAN_IN";
        setTimeout(() => {
          this.getTmoTypes(inbfrom);
        }, 300);
      } else if (dgc == "AM") {
        inbfrom = "SAB_IN";
        setTimeout(() => {
          this.getTmoTypes(inbfrom);
        }, 300);
      } else if (dgc == "SM") {
        inbfrom = "SAB_IN";
        setTimeout(() => {
          this.getTmoTypes(inbfrom);
        }, 300);
      } else if (dgc == "TM") {
        inbfrom = "TMO_IN";
        setTimeout(() => {
          this.getTmoTypes(inbfrom);
        }, 300);
      } else if (dgc == "DM") {
        inbfrom = "DOM";
        setTimeout(() => {
          this.getTmoTypes(inbfrom);
        }, 300);
      }
    },
    async getTmoTypes(inbfrom) {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        inbfrom: inbfrom,
      };

      const response4 = await axios.post(
        `${BASE_API_URL}/outbound-svc/tmotypes/getTmotypesForChange`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
      } else {
        this.tmotypes_new = response4.data;
      }
    },
    searchInb() {
      // console.log("inb");
      this.popupActive6 = true;
    },
    clsd: function () {
      // this.exbdetails = this.itempck = this.packagesCode = this.itemnw = this.nwunit =
      // this.itemgw = this.gwunit = this.dclnumber = this.inbordersNumber = this.itemnum =
      // this.itemqty = this.remark = this.invnum = this.inbitemnum = this.skus_code =
      //   "";
      this.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      // alert("Hi");
      this.$v.$touch();
      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      } else if (this.itempck == 0) {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Package can't be Zero",
          text: "Please Enter The Informaiton",
        });
        return;
      } else if (this.canCondition == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "เงื่อนไขการยกเลิกมีปัญหา",
          text: "กรุณาเลือก เงื่อนไขการยกเลิก",
        });
        return;
      } else if (this.ntmotypesCode == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "กรุณาเลือกประเภท",
          text: "กรุณาเลือก ไปเป็น ประเภท",
        });
        return;
      }

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(this.ata);
      if (token) {
        try {
          const moment = require("moment-timezone");
          const timezone = "Asia/Bangkok";

          // Get the current date and time in the specified timezone
          const now = moment().tz(timezone);

          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            businessPartnersCode: this.businessPartnersCode,
            number: this.recid,
            exbordersNumber: this.exbordersNumber,
            invnum: this.invnum,
            itemnum: this.itemnum,
            inbordersNumber: this.inbordersNumber,
            inbitemnum: this.inbitemnum,
            itemqty: this.itemqty,
            qtyunit: this.qtyunit,
            remark: this.remark,
            acstate: this.acstate,
            recid: this.recid,
            skus_code: this.skus_code,
            mawb: this.mawb,
            hawb: this.hawb,
            dclnumber: this.dclnumber,
            dcldate: this.dcldate,
            repdate: this.repdate,
            shname: this.shname,
            cnname: this.cnname,
            description: this.description,
            canCondition: this.canCondition,
            editor: String(this.userid),
            connumber: this.connumber,
            itempck: this.itempck,
            packagesCode: this.packagesCode,
            itemnw: this.itemnw,
            nwunit: this.nwunit,
            itemgw: this.itemgw,
            gwunit: this.gwunit,
            tmotypesCode: this.tmotypes_code,
            ntmotypesCode: this.ntmotypesCode,
            chreason: this.chreason,
            createdAt: now,
          };

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/chrequests/createChange`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
      // vm.$emit("grid");
      // vm.clsd();
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    // console.log("beforecreate");
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    const formData = {
      inbfrom: "DOM",
    };

    const response4 = await axios.post(
      `${BASE_API_URL}/outbound-svc/tmotypes/getTmotypesALL`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response4.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response4.data.message,
      });
    } else {
      this.tmotypes = response4.data;
    }
  },
  async created() {
    this.checkProfiles();
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    // console.log(this.recid);
    // console.log("create");
    const formData = {
      number: this.recid,
    };
    if (this.recid != "0") {
      // alert("Edit");
      this.readonly = true;

      try {
        const response = await axios.post(
          `${BASE_API_URL}/inbound-svc/chrequests/getCancel`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          // console.log(response.data)
          this.checkForType(response.data.chrequestdetail.refnum);

          setTimeout(() => {
            (this.chRequestsNumber =
              response.data.chrequestdetail.chRequestsNumber),
              (this.inbordersNumber = response.data.chrequestdetail.refnum);
            this.inbitemnum = response.data.chrequestdetail.inbitemnum;
            this.itemqty = response.data.chrequestdetail.itemqty;
            this.qtyunit = response.data.chrequestdetail.qtyunit;
            this.remark = response.data.chrequestdetail.remark;
            this.status = response.data.chrequestdetail.status;
            this.invnum = response.data.chrequestdetail.invnum;
            this.packagesCode = response.data.chrequestdetail.packagesCode;
            this.itemnw = response.data.chrequestdetail.itemnw;
            this.nwunit = response.data.chrequestdetail.nwunit;
            this.itempck = response.data.chrequestdetail.itempck;
            this.itemgw = response.data.chrequestdetail.itemgw;
            this.gwunit = response.data.chrequestdetail.gwunit;
            this.dclnumber = response.data.chrequestdetail.dclnumber;
            this.skus_code =
              response.data.chrequestdetail.skus_code;
            this.mawb = response.data.chrequestdetail.mawb;
            this.hawb = response.data.chrequestdetail.hawb;
            this.indclnumber = response.data.chrequestdetail.indclnumber;
            this.shname = response.data.chrequestdetail.shname;
            this.cnname = response.data.chrequestdetail.cnname;
            this.pod = response.data.chrequestdetail.pod;
            this.dest = response.data.chrequestdetail.dest;
            this.tmotypes_code = response.data.chrequestdetail.tmotypesCode;
            this.ntmotypesCode = response.data.chrequestdetail.ntmotypesCode;
            this.dcldate = response.data.chrequestdetail.dcldate;
            this.description = response.data.chrequestdetail.description;
            this.canCondition = response.data.chrequestdetail.canCondition;
            this.remark = response.data.chrequest.remark;
            this.chreason = response.data.chrequest.chreason;
          }, 1000);

          // setTimeout(() => {
          //   this.onModes2();
          //   this.onModes7();
          // }, 1300);
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
